module.exports = __webpack_public_path__ + "img/photo_books_5.0d27f791.png";